import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { http, formatError } from "@/lib/api";
import { logWarn } from "@/lib/log";

export const foldersChanged = () => window.dispatchEvent(new Event("folders-changed"));

export function useFolders() {
  const [folders, setFolders] = useState([]);
  const load = useCallback(() => http.get("/folders").then((r) => setFolders(r.data)).catch((e) => logWarn("Folders load failed", e)), []);
  useEffect(() => {
    load();
    window.addEventListener("folders-changed", load);
    return () => window.removeEventListener("folders-changed", load);
  }, [load]);
  return folders;
}

export async function newFolder() {
  const name = window.prompt("Folder name");
  if (!name?.trim()) return null;
  try { const { data } = await http.post("/folders", { name }); foldersChanged(); toast.success("Folder created"); return data; }
  catch (e) { toast.error(formatError(e)); return null; }
}

export async function renameFolder(f, name) {
  const t = name.trim();
  if (!t || t === f.name) return;
  try { await http.put(`/folders/${f.folder_id}`, { name: t }); foldersChanged(); toast.success("Folder renamed"); }
  catch (e) { toast.error(formatError(e)); }
}

export async function deleteFolder(f) {
  if (!window.confirm(`Delete the folder "${f.name}"? Its chats stay, they just move back to Recents.`)) return;
  try { await http.delete(`/folders/${f.folder_id}`); foldersChanged(); toast.success("Folder deleted"); }
  catch (e) { toast.error(formatError(e)); }
}
